import { render, staticRenderFns } from "./RecentTracks.vue?vue&type=template&id=6c79cbe0&scoped=true&"
import script from "./RecentTracks.vue?vue&type=script&lang=js&"
export * from "./RecentTracks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c79cbe0",
  null
  
)

export default component.exports